import React from 'react';
import styles from './NotificationsPanel.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const NotificationsPanel = ({ open, onClose }) => {
  return (
    <div
      style={{ display: open ? 'block' : 'none' }}
      className={styles['notifications-panel']}
    >
      <div className={styles['notifications-header']}>
        <p className={styles['title']}>Notifications</p>
        <SvgWithBranding
          type='exit'
          onClick={onClose}
          className={styles['exit-img']}
          color='#011211'
        />
      </div>
      <div className={styles['separator']}></div>
      <div className={styles['notifications-container']}>
        <div className={styles['notifications-item']}>
          <SvgWithBranding type='success' />
          <div className={styles['info-container']}>
            <p className={styles['item-title']}>
              API Sync Finished Successfully
            </p>
            <p className={styles['item-description']}>
              Your API has completed synchronization
            </p>
            <p className={styles['item-time']}>Just Now</p>
          </div>
        </div>
        <div className={styles['notifications-item']}>
          <SvgWithBranding type='failed' />
          <div className={styles['info-container']}>
            <p className={styles['item-title']}>Data import failed</p>
            <p className={styles['item-description']}>
              Unable to process CSV file: invalid format
            </p>
            <p className={styles['item-time']}>20m ago</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationsPanel;
